import Radio from "./Radio";

let _ = require("ES/lib/lodash");
let React = require("ES/lib/react");

let component = React.createFactory(React.createClass({
	__onChange: function(e){
		let field = this.props.field;
		let new_value = e.target.value;
		this.props.onChange(_.has(field.options, new_value) ? new_value : null);
	},
	render: function(){
		let field = this.props.field;
		let value = this.props.value;

		if(field.read_only){
			return <p className="form-control-static">
				{_.has(field.options, value) ? field.options[value] : value}
			</p>;
		}

		let radios = _.map(field.options, _.bind(function(label, v){
			return <Radio
					key={v}
					name={field.name}
					value={v}
					checked={value === v}
					onChange={this.__onChange}
				>
				{label}
			</Radio>;
		}, this));

		return <div>{radios}</div>;
	}
}));

export default {
	component: component
};



// WEBPACK FOOTER //
// ./src/components/inputs/RadioInput.js